export default __webpack_public_path__ + "static/media/26.c5a2872a.jpg";